module.exports = __webpack_public_path__ + "static/media/rail-inspection-session.6ede16d0.png";